import { Component, inject } from '@angular/core';
import { ToastService } from './toast';

@Component({
  selector: 'app-toast-host',
  template: `
    @if (toast.message(); as msg) {
      <div
        class="pointer-events-none fixed inset-x-0 bottom-6 z-[80] flex justify-center px-4"
        role="status"
        aria-live="polite">
        <div
          class="pointer-events-auto flex max-w-md items-center gap-3 rounded-2xl bg-ink px-4 py-3 text-sm text-white shadow-lift">
          <span class="material-symbols-rounded text-beech-soft">check_circle</span>
          <span class="font-medium">{{ msg }}</span>
          <button type="button" class="ml-2 text-white/70 hover:text-white" (click)="toast.dismiss()">
            <span class="material-symbols-rounded text-base">close</span>
          </button>
        </div>
      </div>
    }
  `,
})
export class ToastHostComponent {
  readonly toast = inject(ToastService);
}
